// @flow
import React from 'react';
import { StyledSpan } from '@src/common-utils/styledComponents';

export const TinyHeaderSpan = ({ headerText }) => {
  return <StyledSpan className="ui tiny header">{headerText}</StyledSpan>;
};
